import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function CtaBand() {
  return (
    <section className="relative overflow-hidden rounded-lg bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20dark%20editorial%20background%20with%20warm%20amber%20and%20vermilion%20light%20streaks%20on%20deep%20brown%20texture%2C%20soft%20grain%2C%20minimal%20elegant%2C%20no%20text%2C%20no%20people&width=1600&height=600&seq=kb-home-cta-01&orientation=landscape"
          alt="提供线索背景图"
          title="蝌蚪爆料 - 线索征集"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/80 to-foreground-950/50"></div>
      </div>

      <div className="relative flex flex-col gap-6 px-6 py-10 md:flex-row md:items-center md:justify-between md:px-10 md:py-12">
        <div>
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            看到新进展，或发现我们写错了？
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-200">
            欢迎提供线索、补充材料或指出内容错误。把可公开核实的信息发给我们，核实后会更新到对应事件的时间线上。
          </p>
          <p className="mt-3 text-xs text-background-400">线索邮箱：{siteInfo.tipEmail}</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row md:shrink-0">
          <Link
            to="/contact"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-megaphone-line text-base" aria-hidden="true"></i>
            提供线索
          </Link>
          <Link
            to="/about"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-400/60 px-6 py-3 text-sm font-medium text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
          >
            了解内容原则
          </Link>
        </div>
      </div>
    </section>
  );
}